import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import PostLoginGetApi from '../../../components/Api/PostLoginGetApi';
import PostLoginPostApi from '../../../components/Api/PostLoginPostApi';
import Button from '../../../components/Button';
import init from '../AccessControl/Check';
import { ReactComponent as CloseBtn } from './../../../assets/icons/close.svg';
import { MAX_UPLOAD_FILE_SIZE } from '../../../components/Constants/FileUpload';
import $ from 'jquery';

const UpdateUser = () => {
    const pageName = "User Update";
    const isAccess = init(pageName);

    const navigate = useNavigate();
    const { state } = useLocation();

    const [roleList, setRoleList] = useState([]);



    const fileInput = useRef();
    const [file, setFile] = useState();
    const [mobileNumber, setMobileNumber] = useState(state?.data?.mobile_no);
    const [id, setId] = useState("");





    const [input, setInput] = useState({
        name: "",
        email: "",
        address: "",
        mobileNumber: "",
        logo: "",
        user_type: "",
    })



    useEffect(() => {
        if (state === null || state?.data === undefined || state?.data === "" || state?.data === null) {
            toast.error("No valid user information found.");
            return navigate(-1);
        }

        if (state?.data?.user_type.includes("1")) {
            return navigate(-1);
        }

        setId(state?.data?.id);

        setInput({
            ...input,
            name: state?.data?.name,
            email: state?.data?.email,
            address: state?.data?.address,
            mobileNumber: state?.data?.mobile_no,
            logo: state?.data?.logo,
            user_type: state?.data?.user_type
        });


    }, [state]);


    const handleInputChange = (e) => {
        setInput({ ...input, [e.target.name]: e.target.value });
    }


    const inputNumberHandler = (event) => {
        const res = event.target.value.replace(/\D/g, '');
        setMobileNumber(res);
    }

    const isValidEmail = (email) => {
        return /\S+@\S+\.\S+/.test(email);
    }

    const submitFormData = (event) => {

        event.preventDefault();

        if (!isValidEmail(input.email)) {
            toast.error('Email is invalid');
            return;
        }


        $("button[type=submit]").attr("disabled", true);

        let requestBody = new FormData();
        requestBody.append("name", input.name);
        requestBody.append("email", input.email);
        requestBody.append("mobile_no", mobileNumber);
        requestBody.append("address", input.address);
        requestBody.append("user_type", input.user_type);

        if (file !== undefined) {
            requestBody.append("photo", file);
        }

        // Update User
        PostLoginPostApi("user/update/" + id, requestBody, 3, 1).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    toast.success("User update successfully.");
                    return navigate("/dashboard/user");
                }

                toast.error(responseData["messages"].toString());
            }
        }).catch((error) => {
            toast.error("A problem occur. Please try again.");
            console.log(error);
        }).finally(() => {
            $("button[type=submit]").attr("disabled", false);
            return;
        });

    }




    // Role lists
    useEffect(() => {
        PostLoginGetApi("manage/role", "", 3).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setRoleList(responseData["data"]);
                }
            }
        }).catch((err) => {
            console.log(err);
        })
    }, []);

    // Default Role

    useEffect(() => {
        if (roleList.length === 0) {
            return;
        }

        roleList.forEach(element => {
            if (element.name === state?.data?.user_type.toString()) {
                setInput({ ...input, user_type: element.id });
                return;
            }
        });
    }, [state, roleList]);



    const selectFile = () => {
        fileInput.current.click();
    }

    const handleChange = (e) => {
        if( !e.target?.files[0] ) {
            return;
        }
        
        if(e.target.files[0]["size"] > MAX_UPLOAD_FILE_SIZE) {
            toast.error("Max upload file size is 1 MB.");
            return;
        } 

        
        if (!e.target.files[0]["type"].includes("image/")) {
            toast.error("Please upload valid Image file.");
            return;
        }

        setFile(e.target.files[0]);
    }

    const mobileNumberHandler = (event) => {
        const result = event.target.value.replace(/\D/g, '');
        setMobileNumber("+" + result);
    }

    const cancelFile = () => {
        setFile();
        fileInput.current.value = "";
    }

    if (isAccess === false) {
        return (<>
            <table className="custom-details-table w-full mt-0 mb-2">
                <tbody>
                    <tr>
                        <td className="font-semibold text-base">
                            You do not have any access !
                        </td>
                    </tr>
                </tbody>
            </table>
        </>);
    }


    return (
        <div className="font-medium min-h-[100vh] w-[100%] h-[100%] custom-container-left custom-scroll-auto">
            <div className="font-medium pb-[60px]">
                <header className="flex justify-between items-center p-4 border-b-2 border-dark-white mb-[60px]">
                    <Link to="/dashboard/user"><CloseBtn /></Link>
                    <p className="text-xl text-black text-center">Edit User</p>
                    <div></div>
                </header>
                <main className="max-w-3xl m-auto mb-[60px]">
                    <div className="flex justify-center">
                        <form action='' autoComplete="off" method='POST' className="w-full" onSubmit={(event) => submitFormData(event)} >

                            <h3 className="text-xl mb-[15px]">Create User</h3>

                            <div className="relative py-2 mb-1">
                                <input type="text" name="name" id="name" value={input.name} onChange={handleInputChange} title="name" placeholder=" " className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" required />

                                <label htmlFor="name" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Name *</label>
                            </div>

                            <div className="relative pb-2 pt-1 mb-1">
                                <input type="email" name="email" id="email" value={input.email} onChange={handleInputChange} title="Email" placeholder=" " className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" required />

                                <label htmlFor="email" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Email *</label>
                            </div>

                            <div className="relative pb-2 pt-1 mb-1">
                                <input type="text" name="address" id="address" value={input.address} onChange={handleInputChange} title="Address" placeholder=" " className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" required />

                                <label htmlFor="address" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Address *</label>
                            </div>

                            <div className="relative mt-2 pb-2 pt-1 mb-1">
                                <input type="tel" name="mobileNumber" id="mobileNo" value={mobileNumber} minLength={11} maxLength={11} onChange={inputNumberHandler} title="Mobile Number" placeholder=" " className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" required />

                                <label htmlFor="mobileNo" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Mobile Number *</label>
                            </div>

                            <div className="flex pb-2 pt-1 mb-1 items-center">

                                <div className="flex items-center relative w-[80%] bg-[#f5f5f5] p-2 rounded-md" style={{ border: "1px solid #e0e0e0" }}>
                                    <input type="file" name="tradeLicense" className="hidden" ref={fileInput} onChange={handleChange} />
                                    <label htmlFor="Trade License" className="p-1 text-base font-medium">User Photo</label>

                                    {file ?
                                        <>
                                            {file["type"].includes("image/") ?
                                                <>
                                                    <img src={URL.createObjectURL(file)} alt="Preview Logo" className="max-h-10 max-w-10 ml-auto order-3" />
                                                    <p style={{ fontSize: "10px" }} onClick={() => cancelFile()} className="text-red-700 font-semibold cursor-pointer">cancel</p>
                                                </>
                                                :
                                                <span className="text-xs pr-3">
                                                    {file["name"]}
                                                    <p style={{ fontSize: "10px" }} onClick={() => cancelFile()} className="text-red-700 font-semibold cursor-pointer">cancel</p>
                                                </span>
                                            }

                                            <button type="button" className="text-white ml-auto order-3 bg-[#444] py-[10px] px-[10px] rounded-[3px] cursor-pointer block justify- text-xs" onClick={selectFile}>Change Photo</button>
                                        </> :
                                        <>

                                            <button type="button" className="text-white ml-auto order-2 bg-[#1A202C] py-[10px] px-[25px] rounded-[3px] cursor-pointer block justify- text-base" onClick={selectFile}>Update Photo</button>
                                        </>}
                                </div>
                                <div className="relative w-[49.5%] p-2 rounded-md ml-auto">
                                    <img src={state?.data?.photo} alt="Current Logo" className="float-left max-h-10 max-w-10 ml-auto order-3" />
                                </div>
                            </div>



                            <div className="py-2 mt-1 relative mb-3">
                                <select name="user_type" id="user-type" value={input.user_type} onChange={handleInputChange} className="w-full rounded border-solid border border-dark-white " required>
                                    <option value="" hidden>Role Type *</option>
                                    {roleList.map((data, index) => (
                                        <option key={index} value={data.id} className='text-black'>
                                        {
                                            (data.name === "User") ? 
                                            <>User - KAM</>
                                            :
                                            <>{(data.name === "Owner") ? 
                                                <>User - POC</>
                                                :
                                                <>{data.name}</>
                                            } 
                                            </>
                                        }
                                        </option>
                                    ))}
                                </select>
                            </div>



                            <Button name="Update User"></Button>
                            {/* <button type="submit" className="text-white bg-primary px-10 py-2 mb-3 mt-5 rounded cursor-pointer hover:bg-brand-dark">Submit</button> */}
                        </form>
                    </div>
                </main>
            </div>

            <style>{`
            * :disabled {
                background-color: #F5F5F5 !important;
            }

        `}</style>

        </div>
    );
};

export default UpdateUser;